import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MastersuiteRoutingModule } from './mastersuite.routing.module';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ListComponent } from './list/list.component';
import { SharedModule } from '@app/_shared/shared.module';
import { DetailsComponent } from './details/details.component';
import { DetailsResolver } from './details-resolver';
import { NewComponent } from './new/new.component';
import { UiSwitchModule } from 'ngx-ui-switch';
import { HistoryComponent } from './history/history.component';
import { ResultComponent } from './result/result.component';
import { ExecHistoryComponent } from './exec-history/exec-history.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SharedPipeModule } from "../_pipes/shared-pipe.module";


@NgModule({
  declarations: [ListComponent, DetailsComponent, NewComponent, HistoryComponent, ResultComponent, ExecHistoryComponent],
  imports: [
    CommonModule,
    MastersuiteRoutingModule,
    NgbModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    UiSwitchModule,
    NgSelectModule,
    DragDropModule,
    SharedPipeModule
],
  providers: [DetailsResolver]
})
export class MatersuiteModule { }
